"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abandonedCartMapper = void 0;
var utils_1 = require("../utils");
var buildActivities = function (activities) {
    var flatActivities = [];
    activities.forEach(function (activity, index) {
        flatActivities[index] = {
            activityType: activity.activityType,
            timestamp: utils_1.createWixCodeDateTimeObject.fromISODate(activity.timestamp),
            message: activity.message,
            customData: activity.customData,
        };
    });
    return flatActivities;
};
var buildBuyerInfo = function (buyerInfo) {
    return {
        id: buyerInfo.id,
        identityType: buyerInfo.identityType,
        email: buyerInfo.email,
        phone: buyerInfo.phone,
        firstName: buyerInfo.firstName,
        lastName: buyerInfo.lastName,
    };
};
exports.abandonedCartMapper = function (abandonedCartDTO) {
    return {
        _id: abandonedCartDTO.id,
        abandonTime: utils_1.createWixCodeDateTimeObject.fromISODate(abandonedCartDTO.abandonTime),
        total: abandonedCartDTO.total,
        buyerInfo: abandonedCartDTO.buyerInfo ? buildBuyerInfo(abandonedCartDTO.buyerInfo) : null,
        activities: abandonedCartDTO.activities ? buildActivities(abandonedCartDTO.activities) : null,
        status: abandonedCartDTO.status,
    };
};
//# sourceMappingURL=abandonedCart.mapper.js.map